// Zentrale Link-Konfiguration für energie-monitor-app
// Alle URLs an einer Stelle verwalten

export const LINKS = {
  // Hauptseite
  HOME_URL: 'https://meinerfahrungsbericht.de/',
  
  // Diese App selbst
  APP_URL: 'https://meinerfahrungsbericht.de/tools/energie-monitor/energie-monitor-app/index.html',
  
  // Tarifvergleich (im PDF-CTA klickbar)
  TARIFF_COMPARE_URL: 'https://meinerfahrungsbericht.de/tools/energie-monitor/energie-monitor-app/index.html',
  
  // Erinnerungsservice (Platzhalter - leicht änderbar)
  REMINDER_URL: '',
  
  // Logo
  LOGO_URL: 'https://meinerfahrungsbericht.de/assets/me/me-logo.png',
  
  // Site-Name
  SITE_NAME: 'meinerfahrungsbericht.de',
  
  // App-Name
  APP_NAME: 'Energie-Monitor & Rechner'
};